import React from 'react'
import { Box } from '@material-ui/core'
import SEO from "../components/seo"
import Layout from "../components/Layout/"
import ReferLayout from '../components/Layout/ReferLayout'

const Refer = () => {
    return (
        <>
            <SEO title="Refer" />
            <Layout withFooter withHeader>
                <Box>
                    <ReferLayout />
                </Box>
            </Layout>
        </>
    )
}

export default Refer
